// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__wCoff","inner":"Form_inner__sp-CN","range":"Form_range__34wUr","name":"Form_name__2DcLx","actions":"Form_actions__1p2mD"};